import { Validators } from '@angular/forms';
import { CustomValidators } from './custom-validators';

export class BankValidators {
    static IBAN() {
        return [Validators.required, Validators.minLength(15), CustomValidators.noSpecialCharacters, CustomValidators.removeSpaces];
    }

    static accountHolder() {
        return [CustomValidators.noDigits, CustomValidators.removeSpaces, Validators.required, CustomValidators.latinDigitsSpace];
    }

    static accountNumber() {
        return [Validators.minLength(6), CustomValidators.removeSpaces, Validators.required, CustomValidators.latin];
    }

    static swiftCode() {
        return [CustomValidators.removeSpaces, Validators.required, CustomValidators.latin];
    }

    static bankName() {
        return [CustomValidators.removeSpaces, Validators.required, CustomValidators.latinDigitsSpace];
    }

    static branchName() {
        return [CustomValidators.removeSpaces, Validators.required, CustomValidators.latin];
    }

    static branchAddress() {
        return [CustomValidators.removeSpaces, Validators.required, CustomValidators.latin];
    }
}
